import { toLower } from 'lodash';
import React, { useMemo, useState } from 'react';
import SVG from 'react-inlinesvg';

import { IMAGES_PATH } from 'constants/images.constants';
import { PaymentType } from 'enums';

type Props = {
  bank?: string;
  bankName?: string;
  paymentType?: string;
  paymentTypeName?: string;
  hideDefault?: boolean;
  className?: string;
};

const SPECIAL_LOGOS: Record<string, string> = {
  [PaymentType.SberPay]: 'sberpay.svg',
  [PaymentType.TSBP]: 'tsbp.svg',
};

const BASE_PATH = `${IMAGES_PATH}banks`;
const DEFAULT_LOGO = 'default';

export const SqLogoImage: React.FC<Props> = ({
  bank,
  bankName,
  paymentType = '',
  paymentTypeName = '',
  hideDefault,
  className,
  ...rest
}) => {
  const [hasError, setHasError] = useState(false);

  const logo = useMemo(() => {
    if (!hasError) {
      if (SPECIAL_LOGOS[paymentType]) {
        return SPECIAL_LOGOS[paymentType];
      }

      if (bank || paymentType) {
        return `${toLower(bank || paymentType)}.svg`;
      }
    }

    return hideDefault ? null : `${DEFAULT_LOGO}.svg`;
  }, [bank, hasError, hideDefault, paymentType]);

  const title = useMemo(
    () =>
      `${paymentTypeName} ${
        paymentType in SPECIAL_LOGOS ? '' : bankName || ''
      }`.trim(),
    [paymentTypeName, paymentType, bankName],
  );

  if (!logo) {
    return null;
  }

  return (
    <div className={className}>
      <SVG
        src={`${BASE_PATH}/${logo}`}
        title={title}
        width="100%"
        height="100%"
        onError={() => setHasError(true)}
        {...rest}
      ></SVG>
    </div>
  );
};
